import type { SupplierDto } from '@ops/entities/operation-item';
import { z } from 'zod';

const supplierEntrySchema = z.object({
  id: z.uuid(),
  name: z.string().min(1, 'Supplier name is required'),
  crmType: z.enum(['1', '2']),
  order: z.number().int().nonnegative(),
  selected: z.boolean(),
  primary: z.boolean(),
});

export const supplierChangeFormSchema = z.object({
  itineraryItemIds: z.array(z.uuid()).min(1, 'Select at least one item'),
  suppliers: z.array(supplierEntrySchema),
});

export type SupplierChangeFormValues = z.infer<typeof supplierChangeFormSchema>;

export const defaultSupplierChangeFormValues: SupplierChangeFormValues = {
  itineraryItemIds: [],
  suppliers: [],
};

export const addSupplier = (
  suppliers: SupplierDto[],
  candidate: { id: string; name: string; crmType: '1' | '2' }
): SupplierDto[] => {
  if (suppliers.some((s) => s.id === candidate.id)) return suppliers;
  const isFirst = suppliers.length === 0;
  return [
    ...suppliers,
    {
      id: candidate.id,
      name: candidate.name,
      crmType: candidate.crmType,
      order: suppliers.length,
      selected: true,
      primary: isFirst,
    },
  ];
};

export const removeSupplier = (
  suppliers: SupplierDto[],
  id: string
): SupplierDto[] => {
  const removed = suppliers.find((s) => s.id === id);
  if (!removed) return suppliers;
  const next = suppliers
    .filter((s) => s.id !== id)
    .map((s, idx) => ({ ...s, order: idx }));
  if (removed.primary && next.length > 0 && !next.some((s) => s.primary)) {
    next[0] = { ...next[0], primary: true };
  }
  return next;
};
